import React, {Component} from "react";
import {connect} from "react-redux";
import Dropzone from "react-dropzone";
import {fileFormClear, fileFormSetFiles} from "../../../actions/FileFormActions";
import {Trans} from "react-i18next";
import PropTypes from "prop-types";

class ModalFileForm extends Component {

    handleFiles = (files) => {
        const {fileFormSetFiles, finishCallback, closeModal} = this.props;
        fileFormSetFiles(files);
        closeModal();
        finishCallback();
    };

    componentWillUnmount() {
        this.props.fileFormClear();
    }

    render() {
        return <Dropzone onDrop={files => this.handleFiles(files)}>
            {({getRootProps, getInputProps}) => (
                <div className="popup" {...getRootProps()}>
                    <div className="block">
                        <form className="upload-area">
                            <div className="ico-holder">
                                <img src="/_core/assets/themes/transcription/assets/img/transcription/ico10.svg" alt="image description" />
                            </div>
                            <span className="text"><Trans>Drag and drop files here</Trans></span>
                            <span className="or"><Trans>Or</Trans></span>
                            <button type="button" className="btn"><Trans>UPLOAD FILES</Trans></button>
                            <span
                                className="inform">{this.props.dependencies.allowedMediaExtensions.join(', ')}
                            </span>
                            <input {...getInputProps()} multiple />
                        </form>
                    </div>
                </div>
            )}
        </Dropzone>
    }
}

ModalFileForm.propTypes = {
    dependencies: PropTypes.any,
}

export default connect(
    state => ({
        dependencies: state.dictionary.dependencies,
    }),
    dispatch => ({
        fileFormSetFiles: files => dispatch(fileFormSetFiles(files)),
        fileFormClear: () => dispatch(fileFormClear()),
    })
)(ModalFileForm);